module.exports = __webpack_public_path__ + "static/homepage_foreground-6993dc73dea8fbb1683a00669b013247.png";